/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ABCyaPhaser, { Tweens } from '@abcya/abcya_phaser';
import BasicSprite from '../BasicSprite';
import Phaser from 'phaser';

export default class PlayButton {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    this.playButton = this.scene.add.container(this.scene.scale.width * .5, this.scene.scale.height * .5 + 250);
    const playBtnBg = ABCyaPhaser.Images.addImage(0,0,'playButton', this.playButton);
    ABCyaPhaser.Container.setContainerInteractive(this.playButton).disableInteractive();

    // TODO need font, size, position
    const playBtnText = this.scene.add.bitmapText(0,38, 'Nasalization', ABCyaPhaser.Localization.instance.getLocalizedString('play_button'), 36, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
      .setTint(0xfff8cc);
    this.playButton.add(playBtnText);
    this.playButton.alpha = 0;

    const tween = Tweens.addTween(this.playButton, 500, { alpha: 1 }, Phaser.Math.Easing.None, () => {
      this.PopButton_In();
    });
    this.playButtonScale_Start = 1;
  }

  AnimateOut() {
    this.scene.tweens.killTweensOf(this.playButton);

    Tweens.addTween(this.playButton, 500, { scaleX: 0, scaleY: 0 });
    Tweens.addTween(this.playButton, 500, { alpha: 0 });
  }

  PopButton_In() {
    this.popInTween = Tweens.addTween(this.playButton, 500, { scaleX: this.playButtonScale_Start + .2, scaleY: this.playButtonScale_Start + .2 }, Phaser.Math.Easing.Back.Out, () => {
      this.PopButton_Out();
    });
  }

  PopButton_Out() {
    this.popOutTween = Tweens.addTween(this.playButton, 300, { scaleX: this.playButtonScale_Start, scaleY: this.playButtonScale_Start, completeDelay: 3000 }, Phaser.Math.Easing.Back.Out, () => {
      this.PopButton_In();
    });
  }

  Button() {
    return this.playButton;
  }
}


